import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { vendorApi } from '../api/vendorApi'

export function useVendor(vendorId: string) {
  const queryClient = useQueryClient()

  const vendorQuery = useQuery({
    queryKey: ['vendor', vendorId],
    queryFn: () => vendorApi.fetchVendor(vendorId),
    enabled: !!vendorId,
  })

  const updateCoverImageMutation = useMutation({
    mutationFn: (imageFile: File) => vendorApi.updateCoverImage(vendorId, imageFile),
    onSuccess: (newCoverImage) => {
      // Update the cached vendor data with the new cover image
      queryClient.setQueryData(['vendor', vendorId], (old: any) => 
        old ? { ...old, coverImage: newCoverImage } : old
      )
    },
  })

  return {
    vendor: vendorQuery.data,
    isLoading: vendorQuery.isLoading,
    refetch: vendorQuery.refetch,
    updateCoverImage: updateCoverImageMutation.mutateAsync,
    isUpdatingCoverImage: updateCoverImageMutation.isPending,
  }
}
